import { useMemo } from 'react'
import { useSuspenseQuery } from '@apollo/client'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'
import { useParams } from 'wouter'
import { useLingui } from '@lingui/react/macro'

import { Suspense } from '@/components/ui/Suspense'
import { DialogHeader } from '@/layouts/Dialog'
import { SpaceForm } from '@/features/space'
import { useCloseModal } from '@/Router'

function Space({ identifier }: { identifier: string }) {
  const { t } = useLingui()
  const closeModal = useCloseModal()

  const { data } = useSuspenseQuery(AdminAPI.space.GET_BY_IDENTIFIER, {
    variables: { identifier },
    fetchPolicy: 'cache-and-network'
  })

  const space = useMemo(() => {
    if (!data) return

    return getFragment(
      SharedAPI.space.SPACE_FRAGMENT,
      data.getSpaceByIdentifier
    )
  }, [data])

  if (!space) return null

  const spaceIdentifier = space.identifier

  return (
    <div className="flex flex-col gap-7 p-5">
      <DialogHeader
        title={spaceIdentifier}
        description={t`Details of room with the number ${spaceIdentifier}.`}
      />
      <SpaceForm space={space} onCancel={closeModal} onDone={closeModal} />
    </div>
  )
}

export default function SpaceSuspense() {
  const params = useParams() as { identifier: string }

  if (!params) return null

  return (
    <Suspense isDialog>
      <Space identifier={params.identifier} />
    </Suspense>
  )
}
